import React, { FC, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import ConfirmationModal from "../../modules/ConfirmationModal";

type CRMRetargetingModalProps = {
  triggerCondition?: boolean;
};

const CRMRetargetingModal: FC<CRMRetargetingModalProps> = ({ triggerCondition }) => {
  const history = useHistory();

  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(() => {
    if (triggerCondition !== undefined) {
      return triggerCondition;
    }
    return !localStorage.getItem("crmRetargetingPromptDismissed");
  });

  useEffect(() => {
    if (triggerCondition && !localStorage.getItem("crmRetargetingPromptDismissed")) {
      setIsConfirmationModalOpen(true);
    }
  }, [triggerCondition]);

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
    history.push("/advertisers/");
  };

  const closeConfirmationModal = () => {
    localStorage.setItem("crmRetargetingPromptDismissed", "true");
    setIsConfirmationModalOpen(false);
  };

  return (
    <ConfirmationModal
      isOpen={isConfirmationModalOpen}
      handleClose={closeConfirmationModal}
      handleConfirm={openConfirmationModal}
      confirmButtonLabel="Go to Advertisers"
      confirmQuestion={
        "We've introduced CRM Re-targeting in BrandGen.io. To start using this feature, please reconnect your HubSpot account to your BrandGen account for the Advertiser that you want to enable this functionality for. Go to the Advertiser Details page and click Update to complete the process."
      }
      confirmTitle="New Feature Available: CRM Re-targeting"
      cancelTitle="Already updated"
    />
  );
};

export default CRMRetargetingModal;
